import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import DriverDashboard from "@/pages/DriverDashboard";
import AdminDashboard from "@/pages/AdminDashboard";

function Router() {
  const { user, ready } = useAuth();

  if (!ready)
    return (
      <div className="grain min-h-screen flex items-center justify-center text-slate-400">
        <div className="animate-pulse font-display text-xl">Chargement…</div>
      </div>
    );

  return (
    <Routes>
      <Route
        path="/login"
        element={!user ? <Login /> : <Navigate to={user.role === "admin" ? "/admin" : "/driver"} />}
      />
      <Route
        path="/driver"
        element={user && user.role === "driver" ? <DriverDashboard /> : <Navigate to="/login" />}
      />
      <Route
        path="/admin"
        element={user && user.role === "admin" ? <AdminDashboard /> : <Navigate to="/login" />}
      />
      <Route
        path="*"
        element={<Navigate to={user ? (user.role === "admin" ? "/admin" : "/driver") : "/login"} />}
      />
    </Routes>
  );
}

function App() {
  return (
    <div className="App grain">
      <AuthProvider>
        <BrowserRouter>
          <Router />
        </BrowserRouter>
      </AuthProvider>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
